import type { AdCampaign } from '../model/types'

export enum AdCampaignType {
    purchase = 'purchase',
    sale = 'sale'
}

export interface CreateAdCampaignArgs {
    name: string
    type: AdCampaignType
    channel: number
}

export interface CreateAdCampaignArgsDTO {
    name: string
    type: AdCampaignType
    channel: number
}

export interface EditAdCampaignArgs {
    id: number
    data: Omit<AdCampaign, 'id'>
}

export interface DeleteAdCampaignArgs {
    id: number
}
